module.exports = __webpack_public_path__ + "img/associationMapWhite.688eaf4e.svg";